var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "print-or-save-dialog-container" },
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.texts.title } }),
      _c(
        "div",
        { staticClass: "step-wizard-container" },
        [
          _setup.hasDocumentGenerated
            ? _c("ejs-pdfviewer", {
                attrs: {
                  id: "pdf-viewer",
                  documentPath: _setup.documentPath,
                  resourceUrl: _setup.resourceUrl,
                  enableToolbar: false,
                  enableThumbnail: false,
                  enableNavigationToolbar: false,
                },
              })
            : _c(_setup.SpinnerLayerComponent, {
                staticClass: "spinner-layer",
                attrs: { loadingText: _setup.texts.spinner },
              }),
          _c(
            "div",
            { staticClass: "dialog-actions-container" },
            [
              _c(_setup.LfActionsBarComponent, {
                staticClass: "action-buttons",
                attrs: { showKebabMenu: false, buttons: _setup.buttons },
                on: { "execute-action": _setup.onExecuteAction },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }